export const sizeMap = {
  sm: 12,
  md: 24,
  lg: 32,
} as const
